import { render, staticRenderFns } from "./ProjectFindings.vue?vue&type=template&id=02c3b804&"
import script from "./ProjectFindings.vue?vue&type=script&lang=js&"
export * from "./ProjectFindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports